import React, { useState } from "react";
import AdminNavbar from "./AdminNavbar";
import AdminSideBar from "./AdminSideBar";
import "../../../asset/new/css/admin-modern.css";

/**
 * AdminLayout - Reusable layout component for all admin pages
 * Provides consistent navbar, sidebar, and content area structure
 * 
 * @param {string} title - Page title
 * @param {string} subtitle - Page subtitle (optional)
 * @param {array} breadcrumbs - Breadcrumb items [{label, active}]
 * @param {node} children - Page content
 * @param {node} actions - Action buttons in header (optional)
 */
const AdminLayout = ({ 
  title, 
  subtitle, 
  breadcrumbs = [], 
  children,
  actions 
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-wrapper">
      <AdminNavbar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      <div className="d-flex" style={{ position: 'relative' }}>
        <AdminSideBar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="admin-main" style={{ flex: 1 }}>
          <div className="admin-content">
            {/* Page Header */}
            {(title || breadcrumbs.length > 0) && (
              <div className="admin-page-header">
                {breadcrumbs.length > 0 && (
                  <div className="admin-page-breadcrumb">
                    {breadcrumbs.map((item, index) => (
                      <React.Fragment key={index}>
                        {index > 0 && <span className="admin-page-breadcrumb-separator">/</span>}
                        <span className={`admin-page-breadcrumb-item ${item.active ? 'active' : ''}`}>
                          {item.label}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                )}
                <div className="admin-flex admin-items-center admin-justify-between">
                  <div>
                    {title && <h1 className="admin-page-title">{title}</h1>}
                    {subtitle && <p className="admin-page-subtitle">{subtitle}</p>}
                  </div>
                  {actions && <div className="admin-flex admin-gap-sm">{actions}</div>}
                </div>
              </div>
            )}

            {/* Page Content */}
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
